<template>
  <div id="publication" class="publication-single">
    <sub-menu id="section-submenu" nohide="true"></sub-menu>
    <div class="card relative border mx-auto">
      <div class="row clearfix flex">
        <card-block
          width="33"
          header="Author"
          :content="authors">
          </card-block>
        <card-block
          width="33"
          header="Publication Date"
          :content="publicationDate">
          </card-block>
        <card-block
          width="33"
          header="Price"
          :content="publicationPrice">
          </card-block>
      </div>
      <div class="row clearfix flex">
        <div class="caps flex items-center col-12">
          <div class="mx-auto fs-s p2 flex-auto center">Download PDF</div>
          <div class="mx-auto fs-s p2 border-left flex-auto center">Buy The Book</div>
        </div>
      </div>
    </div>

    <div class="clearfix mt3 col-6 mx-auto">
      <div class="col col-4 p2">
        <img class="thumbnail mx-auto" :src="publicationCover" />
        <div class="fs-s" v-html="publicationDetails"></div>
      </div>
      <div class="col col-8 sans p2">
        <div class="copy" v-html="publicationContent"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { joinArray, formatDate } from '@/utils'
import SubMenu from '@/components/SubMenu'
import CardBlock from '@/components/CardBlock'

export default {

  name: 'Publication',

  data () {
    return {
      slug: this.$route.params.slug
    }
  },

  components: {
    CardBlock,
    SubMenu
  },

  computed: {
    ...mapState([
      'pages'
    ]),
    ...mapGetters([
      'getPublicationBySlug'
    ]),
    authors () {
      return this.joinArray(this.publication.acf.author, "-")
    },
    contributors () {
      return this.joinArray(this.publication.acf.contributors, "-")
    },
    publication () {
      return this.getPublicationBySlug(this.slug)
    },
    publicationContent () {
      return this.publication.acf.description
    },
    publicationCover () {
      if (this.publication.acf.cover_image) {
        return this.publication.acf.cover_image.sizes['large']
      } else {
        return false
      }
    },
    publicationDate () {
      if (this.publication.acf.publication_date !== "") {
        return this.formatDate(this.publication.acf.publication_date)
      } else {
        return "-"
      }
    },
    publicationDetails (){
      return this.publication.acf.publication_details
    },
    publicationISBN () {
      return this.publication.acf.isbn
    },
    publicationPrice () {
      return this.publication.acf.price
    }
  },

  methods: {
    joinArray,
    formatDate,
    ...mapActions([
      'getPage'
    ])
  },

  watch: {
    '$route' (to) {
      this.getPage(to.params.page)
    }
  }
}
</script>

<style lang="css" scoped>
  .card {
    max-width: var(--max-width-med);
    margin-top: 1em;
  }
</style>
